import { create } from 'zustand';

// Mock data for friends
const friends = [
  { 
    id: 1, 
    name: 'Alex Johnson', 
    username: '@alexj', 
    isOnline: true, 
    activity: 'Playing Basketball at Central Park', 
    avatar: null 
  },
  { 
    id: 2, 
    name: 'Sarah Williams', 
    username: '@sarahw', 
    isOnline: true, 
    activity: 'Running at Riverside Trail', 
    avatar: null 
  },
  { 
    id: 3, 
    name: 'Mike Brown', 
    username: '@mikeb', 
    isOnline: false, 
    lastSeen: '2h ago', 
    activity: null, 
    avatar: null 
  },
  { 
    id: 4, 
    name: 'Emma Davis', 
    username: '@emmad', 
    isOnline: true, 
    activity: 'At Metro Sports Center', 
    avatar: null 
  },
  { 
    id: 5, 
    name: 'Chris Wilson', 
    username: '@chrisw', 
    isOnline: false, 
    lastSeen: '5h ago', 
    activity: null, 
    avatar: null 
  },
];

// Mock data for activity feed
const activityFeed = [
  { 
    id: 1, 
    type: 'joined_event', 
    user: friends[0], 
    event: 'Weekend Basketball Pickup', 
    time: '10 min ago' 
  },
  { 
    id: 2, 
    type: 'achievement', 
    user: friends[1], 
    achievement: '10K Runner', 
    time: '1 hour ago' 
  },
  { 
    id: 3, 
    type: 'check_in', 
    user: friends[2], 
    venue: 'Metro Sports Center', 
    time: '3 hours ago' 
  },
  { 
    id: 4, 
    type: 'highlight', 
    user: friends[3], 
    description: 'Shared a new highlight video', 
    time: '5 hours ago' 
  },
];

// Mock data for groups
const groups = [
  { 
    id: 1, 
    name: 'NYC Ballers', 
    memberCount: 145, 
    unreadCount: 3, 
    image: null,
    sport: 'basketball'
  },
  { 
    id: 2, 
    name: 'Morning Runners', 
    memberCount: 89, 
    unreadCount: 0, 
    image: null,
    sport: 'running'
  },
  { 
    id: 3, 
    name: 'Weekend Warriors', 
    memberCount: 234, 
    unreadCount: 12, 
    image: null,
    sport: 'soccer'
  },
];

// Mock data for suggested connections
const suggestions = [
  { 
    id: 6, 
    name: 'Chris Lee', 
    mutualFriends: 3, 
    sport: 'Basketball', 
    avatar: null 
  },
  { 
    id: 7, 
    name: 'Jordan Taylor', 
    mutualFriends: 5, 
    sport: 'Running', 
    avatar: null 
  },
  { 
    id: 8, 
    name: 'Sam Rodriguez', 
    mutualFriends: 2, 
    sport: 'Tennis', 
    avatar: null 
  },
];

// Pending invites count
const pendingInvites = 2;

/**
 * Social Store - Manages social hub state
 * 
 * State:
 * - friends: List of user's friends
 * - activityFeed: Friend activity stream
 * - groups: User's joined groups
 * - suggestions: People you may know
 * - pendingInvites: Number of pending friend/group invites
 */
export const useSocialStore = create((set, get) => ({
  // State
  friends,
  activityFeed,
  groups,
  suggestions,
  pendingInvites,
  
  // UI State
  isLoading: false,
  selectedFriend: null,
  selectedGroup: null,

  // Actions
  setSelectedFriend: (friend) => set({ selectedFriend: friend }),
  setSelectedGroup: (group) => set({ selectedGroup: group }),
  
  // Send message to friend (mock)
  sendMessage: (friendId, message) => {
    console.log(`Sending message to friend ${friendId}: ${message}`);
    // In a real app, this would call an API
  },
  
  // Add friend from suggestions (mock)
  addFriend: (suggestionId) => {
    const state = get();
    const suggestion = state.suggestions.find(s => s.id === suggestionId);
    if (suggestion) {
      const newFriend = {
        ...suggestion,
        username: `@${suggestion.name.toLowerCase().replace(' ', '')}`,
        isOnline: false,
        lastSeen: 'Just now',
        activity: null,
      };
      set({
        friends: [...state.friends, newFriend],
        suggestions: state.suggestions.filter(s => s.id !== suggestionId),
      });
    }
  },
  
  // Accept invite (mock)
  acceptInvite: () => {
    set((state) => ({
      pendingInvites: Math.max(0, state.pendingInvites - 1),
    }));
  },
  
  // Mark group messages as read (mock)
  markGroupRead: (groupId) => {
    const state = get();
    const updatedGroups = state.groups.map(group =>
      group.id === groupId ? { ...group, unreadCount: 0 } : group
    );
    set({ groups: updatedGroups });
  },
  
  // Refresh data (mock)
  refreshData: () => {
    set({ isLoading: true });
    setTimeout(() => {
      set({ isLoading: false });
    }, 500);
  },
}));

export default useSocialStore;
